/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Preview_Col_YoursInputs */

const da_forside_preview_col_yours = /** @type {(inputs: Forside_Preview_Col_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dine point`)
};

/** @type {(inputs: Forside_Preview_Col_YoursInputs) => LocalizedString} */
const en_forside_preview_col_yours = da_forside_preview_col_yours;

/**

* @param {Forside_Preview_Col_YoursInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_preview_col_yours = /** @type {((inputs?: Forside_Preview_Col_YoursInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Preview_Col_YoursInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_preview_col_yours(inputs)
	return /** @type {LocalizedString} */ ("Dine point")
});